import { CSSProperties, ReactNode, FunctionComponent } from 'react';
import { withStyles } from 'vopay';
import styles from './DetailsCard.module.scss';

const cn = withStyles(styles);

type DetailsCardProps = {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
};

const DetailsCard: FunctionComponent<DetailsCardProps> = ({ children, className, style }) => (
  <div className={[cn('card'), className].filter(Boolean).join(' ')} style={style}>
    {children}
  </div>
);

export default DetailsCard;
